<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Stores
	import ParentMarketStore from '@/Stores/Sport/ParentMarketStore';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	// Services
	import { notify } from '@/Services/Notify';
	import MarketTypeStore from '@/Stores/Sport/MarketTypeStore';
	import SportStore from '@/Stores/Sport/SportStore';

	export let sport;
	export let open;

	const dispatch = createEventDispatcher();

	let sending = false;
	let errors = null;
	let marketTypes = [];

	let parentMarketForm = {
		sport_id: sport.id,
		name: '',
		market_type_id: false
	};

	$: sport && $SportStore && getMarketTypes();

	function getMarketTypes() {
		MarketTypeStore.getMarketTypesForSport(sport.id).then(() => {
			marketTypes = $MarketTypeStore.sortBy('name').all() ?? [];
		});
	}

	function createParentMarket() {
		sending = true;
		ParentMarketStore.createParentMarket(parentMarketForm)
			.then(() => {
				notify({
					type: 'success',
					title: 'Parent market created',
					message: `Parent market successfully created for ${sport.name}!`,
					timeout: 3
				});
				dispatch('created');
				open = false;
				parentMarketForm = {
					sport_id: sport.id,
					name: '',
					start_time: ''
				};
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Error!',
					message: 'Problem creating parent market',
					timeout: 3
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">
			Create parent market for {sport.name}
		</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<TextInput
				label="Name"
				name="parentMarketName"
				className="py-4 w-full text-left"
				errors={errors && errors.name}
				placeholder="Enter new parent market name"
				bind:value={parentMarketForm.name}
			/>
			<SelectInput
				label="Market type"
				className="py-4 w-full text-left"
				name="parentMarketMarketType"
				required={true}
				bind:value={parentMarketForm.market_type_id}
			>
				<option value={false}>Select market type</option>
				{#each marketTypes as marketType (marketType.id)}
					{#if marketType.id === parseInt(parentMarketForm.market_type_id)}
						<option value={marketType.id} selected
							>{marketType.name}
							{#if marketType.label != null}[{marketType.label}]{/if}
						</option>
					{:else}
						<option value={marketType.id}
							>{marketType.name}
							{#if marketType.label != null}[{marketType.label}]{/if}
						</option>
					{/if}
				{/each}
			</SelectInput>
			<LoadingButton on:click={() => createParentMarket()} loading={sending} className="mb-4 btn btn-primary">
				{sending ? 'Creating' : 'Create'}
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}>Cancel</button>
		</div>
	</Modal>
{/if}
